// Web shim for app/src/components/Logger.js.
//
// darwin_core only uses Logger's default-export logging interface
// (Logger.log/.debug/.warning/.error). The real module also exports a React
// Native error-fallback component that drags in native views, so on the web we
// provide just the logging interface and drop the component. Kept byte-for-byte
// compatible with the mobile default export.
//
// PRIVACY: log/debug are the verbose channels — the WebSocket transport routes
// every inbound/outbound frame through them, so they carry full home/zone
// telemetry. They are gated on the __WEB_LOGGING__ build constant (see
// vite.config.js), which is true for local dev and the debuggable deploy builds
// (dev + staging) and false for production. Since __WEB_LOGGING__ is a literal at
// build time, the production bundle dead-code-eliminates these console calls
// entirely, so user data never reaches an end user's browser console. warning and
// error are always kept — genuine problems must still surface (and they log a
// message/error, not raw frames).
export default {
  log: (...args) => {
    if (__WEB_LOGGING__) {
      console.log(new Date().toISOString(), ...args);
    }
  },
  debug: (...args) => {
    if (__WEB_LOGGING__) {
      console.debug(new Date().toISOString(), ...args);
    }
  },
  warning: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};
